import React, { useState } from "react";
import Autocomplete from "../../prescription/services/autocomplete";
import dayjs from "dayjs";
import moment from "moment";

const PatientAutocomplete = ({
  patient,
  setPatient,
  patientDetails,
  setPatientDetails,
  setName,
  setGender,
  setAge,
  setBirthDate,
  isNewRelatedPatient,
  setIsNewRelatedPatient,
  checkRelatedPatient,
  setCheckRelatedPatient,
  resetForm,
}) => {
  const handlePatientChange = (selectedPatient) => {
    setPatient(selectedPatient.phone_number);
    setPatientDetails(selectedPatient);
    setName(selectedPatient.full_name);
    setIsNewRelatedPatient(false);
    setCheckRelatedPatient(false);
    setGender(selectedPatient.gender || ""); // Set the gender if available, otherwise set to an empty string
    setAge(selectedPatient.age || ""); // Set the age if available, otherwise set to an empty string
    setBirthDate(
      dayjs(moment(selectedPatient.date_of_birth).format("YYYY-MM-DD")) || ""
    );
  };

  const handleNewRelatedPatientChange = (event) => {
    setIsNewRelatedPatient(event.target.checked);
    setCheckRelatedPatient(event.target.checked);
    if (event.target.checked) {
      setName("");
      setGender("");
      setAge("");
      setBirthDate("");
    } else {
      if (patientDetails && patientDetails.full_name) {
        setName(patientDetails.full_name);
        setGender(patientDetails.gender || ""); // Set the gender if available, otherwise set to an empty string
        setAge(patientDetails.age || ""); // Set the age if available, otherwise set to an empty string
        setBirthDate(
          dayjs(moment(patientDetails.date_of_birth).format("YYYY-MM-DD")) || ""
        );
      }
    }
  };

  return (
    <div>
      <Autocomplete
        name="patient"
        setname={setName}
        value={patient}
        onChange={(e) => setPatient(e.target.value)}
        placeholder="Search for a patient"
        onSuggestionSelected={handlePatientChange}
        setIsNewRelatedPatient={setIsNewRelatedPatient}
        setPatientDetails={setPatientDetails}
        setCheckRelatedPatient={setCheckRelatedPatient}
        resetForm={resetForm}
      />
      {patientDetails && patientDetails.patient_id && (
        <label>
          <input
            type="checkbox"
            checked={isNewRelatedPatient}
            onChange={handleNewRelatedPatientChange}
            className=" mr-2"
          />
          Add new related patient
        </label>
      )}
    </div>
  );
};

export default PatientAutocomplete;
